import { db } from "./firebase";
import { doc, onSnapshot } from "firebase/firestore";
const envPrefix = process.env.REACT_APP_ENV || "";
const COLLECTION_NAME = `${envPrefix}needle_eye_desktop_sync`;

export const listenDesktopAgent = (documentId, callback) => {
  return onSnapshot(doc(db, COLLECTION_NAME, documentId), (docSnap) => {
    if (docSnap.exists()) {
      callback(docSnap.data());
    } else {
      console.warn("⚠️ Desktop doc missing");
      callback(null);
    }
  });
};
